import { Link, useParams } from '@tanstack/react-router';
import type { FC } from 'react';
import useAuth from 'src/hooks/auths/useAuth';
import OrganizationalTitle from './OrganizationalTitle';

const SidebarTitle: FC = () => {
  const { isRootUserValidated } = useAuth();
  const isEventPath = false;
  const { organizationSlug } = useParams({
    strict: false,
  });

  return (
    <div className="px-2 h-12 gray-box">
      {isRootUserValidated && (organizationSlug || isEventPath) ? (
        <OrganizationalTitle />
      ) : (
        <Link to="/" className="flex h-full items-center">
          Project Juno
        </Link>
      )}
    </div>
  );
};

export default SidebarTitle;
